import styled from '@emotion/styled';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Link from 'next/link';

import CompareCarIcon from '../icons/compare-car-icon';

import { BREAKPOINTS, COLORS, FONT_SIZE, FONT_WEIGHT, GLOBAL, SPACE } from '@/constants';

export const StyledLabel = styled.span`
  font-size: ${FONT_SIZE.MEDIUM};
  font-weight: ${FONT_WEIGHT.LIGHT};
  font-family: ${GLOBAL.BRAND_FONT_FAMILY_SECOND};
  display: block;
  text-transform: uppercase;
  margin-bottom: 16px;
`;

export const StyledContainer = styled(Box)`
  margin-bottom: ${SPACE.X1};
  width: 100%;

  @media (min-width: ${BREAKPOINTS.LG}px) {
    margin-top: ${SPACE.X1};
    width: 320px;
  }
`;

export const StyledSaferVariantCard = styled(Box)`
  background-color: ${COLORS.WHITE};
  padding: ${SPACE.X1};
  filter: drop-shadow(0 2px 11px ${COLORS.GREY_FOUR});
`;

export const StyledVehicleDescription = styled.p`
  color: ${COLORS.GREY_ELEVEN};
  font-family: ${GLOBAL.BRAND_FONT_FAMILY};
  font-size: ${FONT_SIZE.MEDIUM};
  margin-bottom: 12px;
`;

export const StyledDetailList = styled.dl`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 12px 0 18px 0;
`;

export const StyledDetailLabel = styled.dt`
  font-size: ${FONT_SIZE.X_SMALL};
  font-family: ${GLOBAL.BRAND_FONT_FAMILY_SECOND};
  margin: 0;
  line-height: 1;
`;

export const StyledDetailValue = styled.dd`
  font-family: ${GLOBAL.BRAND_FONT_FAMILY};
  font-size: ${FONT_SIZE.MEDIUM};
  margin: 0;
  line-height: 1;
`;

export const StyledLink = styled(Link)`
  color: ${COLORS.BRAND_BLUE_NINE};
  font-family: ${GLOBAL.BRAND_FONT_FAMILY};
  font-size: ${FONT_SIZE.SMALL};

  &:hover {
    text-decoration: underline;
  }

  @media (min-width: ${BREAKPOINTS.LG}px) {
    font-size: ${FONT_SIZE.MEDIUM};
  }
`;

export const BlueCompareCarIcon = styled(CompareCarIcon)`
  fill: ${COLORS.BRAND_BLUE_NINE};

  path {
    fill: ${COLORS.BRAND_BLUE_NINE};
  }
`;

export const StyledLinkButton = styled(Button)`
  && {
    color: ${COLORS.BRAND_BLUE_NINE};
    font-family: ${GLOBAL.BRAND_FONT_FAMILY};
    font-size: ${FONT_SIZE.SMALL};
    padding: 0;
    min-width: auto;
    text-transform: none;
    background: none;

    &:hover {
      background: none;
      text-decoration: underline;
    }

    &.MuiButton-startIcon {
      margin-right: 6px;
    }

    @media (min-width: ${BREAKPOINTS.LG}px) {
      font-size: ${FONT_SIZE.MEDIUM};
    }
  }

  &.MuiButton-startIcon {
    svg {
      fill: ${COLORS.BRAND_BLUE_NINE};
      color: ${COLORS.BRAND_BLUE_NINE};
    }
  }
`;
